export const notificationMixin = {
  methods: {
    showMessage(type, message, title) {
      this.$vs.notify({
        title: title,
        text: message,
        time: 4000,
        color: type,
        position: "top-right",
      });
    },
  },
};
